/**
 * The pages router keeps `{ url, as, options, __N, key }` in `history.state`, and its popstate
 * handler returns early for any entry whose state lacks `__N`. Passing a fresh object to
 * `history.replaceState`/`pushState` therefore strips the marker and leaves Back changing the
 * address bar without restoring the route. Carrying the existing state forward — and pointing
 * `url`/`as` at the new address so the router's `asPath` stays truthful — keeps Back working.
 */
export const currentHistoryState = (): Record<string, unknown> => {
  const current: unknown = window.history.state;
  return typeof current === 'object' && current !== null ? { ...current } : {};
};

const withRouterState = (url: string): Record<string, unknown> => ({
  ...currentHistoryState(),
  url,
  as: url,
});

/** Rewrite the current history entry's URL without triggering a route change. */
export const replaceUrl = (url: string): void => {
  window.history.replaceState(withRouterState(url), '', url);
};

/** Add a history entry for `url` without triggering a route change. */
export const pushUrl = (url: string): void => {
  window.history.pushState(withRouterState(url), '', url);
};
